export enum GradientClass {
  Right = 'scroll-gradient-right',
  Bottom = 'scroll-gradient-bottom',
}
